import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state id for the Work-home "Set your default page" banner. Cast until the
 * schema regenerates with the ml-scribe member; the string is frozen (it keys
 * `seen_modals`).
 */
export const DEFAULT_LANDING_PAGE_BANNER_MODAL_ID =
  'T4_CUSTOM_AUDIENCE_DEFAULT_LANDING_PAGE_BANNER' as ModalId;
